import { render, staticRenderFns } from "./EmailTemplatesPage.vue?vue&type=template&id=5ebc9d60"
import script from "./EmailTemplatesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplatesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports